import { getWithAuthentication } from './http'

//@deprecated use getPropertyById
export const getProperty = (propertyId) =>
  getWithAuthentication(`${process.env.REACT_APP_PROPERTY_API}/${propertyId}`).then((res) => res.data)

export const getPropertyById = (id) =>
  getWithAuthentication(`${process.env.REACT_APP_PROPERTY_API}/${id}`).then((res) => res.data)
